export interface Category {
  name: string;
  url: string;
  image: string;
  tagline: string;
}

export const categories: Category[] = [
  {
    name: "Shoes",
    url: "https://kaspreadsheet.com/category-911-Shoes.html",
    image:
      "https://readdy.ai/api/search-image?query=A%20pair%20of%20modern%20sage%20green%20and%20cream%20chunky%20sneakers%20photographed%20on%20a%20soft%20mint%20green%20studio%20backdrop%20with%20gentle%20warm%20lighting%20and%20a%20subtle%20soft%20shadow%2C%20clean%20e-commerce%20product%20photography%2C%20high%20detail%2C%20balanced%20composition&width=600&height=600&seq=cat-shoes-v2&orientation=squarish",
    tagline: "Sneakers, trainers & more",
  },
  {
    name: "Hoodies/Sweaters",
    url: "https://kaspreadsheet.com/search-912/name/Shoes.html",
    image:
      "https://readdy.ai/api/search-image?query=A%20cozy%20oversized%20oatmeal%20beige%20hooded%20sweatshirt%20hanging%20on%20a%20light%20wooden%20hanger%20against%20a%20warm%20terracotta%20studio%20backdrop%2C%20soft%20natural%20lighting%2C%20minimal%20e-commerce%20product%20photography%2C%20high%20detail%2C%20clean%20balanced%20composition&width=600&height=600&seq=cat-hoodies-v2&orientation=squarish",
    tagline: "Cozy hoodies & sweaters",
  },
  {
    name: "T-Shirts",
    url: "https://kaspreadsheet.com/search-913/name/Shoes.html",
    image:
      "https://readdy.ai/api/search-image?query=A%20neatly%20folded%20sand%20beige%20cotton%20t-shirt%20stack%20on%20a%20warm%20cream%20linen%20surface%20against%20a%20soft%20blush%20pink%20studio%20backdrop%2C%20gentle%20morning%20light%2C%20minimal%20e-commerce%20product%20photography%2C%20high%20detail%2C%20balanced%20composition&width=600&height=600&seq=cat-tshirts-v2&orientation=squarish",
    tagline: "Everyday tees & basics",
  },
  {
    name: "Jackets",
    url: "https://kaspreadsheet.com/search-914/name/Shoes.html",
    image:
      "https://readdy.ai/api/search-image?query=A%20modern%20olive%20green%20lightweight%20bomber%20jacket%20laid%20flat%20on%20a%20warm%20tan%20leather%20surface%20against%20a%20soft%20stone%20grey%20studio%20backdrop%2C%20gentle%20natural%20lighting%2C%20minimal%20e-commerce%20product%20photography%2C%20high%20detail%2C%20clean%20composition&width=600&height=600&seq=cat-jackets-v2&orientation=squarish",
    tagline: "Light layers & outerwear",
  },
  {
    name: "Pants/Shorts",
    url: "https://kaspreadsheet.com/search-915/name/Shoes.html",
    image:
      "https://readdy.ai/api/search-image?query=A%20pair%20of%20relaxed%20fit%20beige%20cargo%20trousers%20folded%20neatly%20on%20a%20soft%20sand%20colored%20surface%20against%20a%20warm%20cream%20studio%20backdrop%2C%20gentle%20natural%20lighting%2C%20minimal%20e-commerce%20product%20photography%2C%20high%20detail%2C%20balanced%20composition&width=600&height=600&seq=cat-pants-v2&orientation=squarish",
    tagline: "Pants, joggers & shorts",
  },
  {
    name: "Headwear",
    url: "https://kaspreadsheet.com/search-916/name/Shoes.html",
    image:
      "https://readdy.ai/api/search-image?query=A%20structured%20forest%20green%20baseball%20cap%20resting%20on%20a%20rustic%20light%20wood%20block%20against%20a%20soft%20sage%20studio%20backdrop%2C%20warm%20side%20lighting%2C%20minimal%20e-commerce%20product%20photography%2C%20high%20detail%2C%20clean%20composition&width=600&height=600&seq=cat-headwear-v2&orientation=squarish",
    tagline: "Caps, beanies & hats",
  },
  {
    name: "Sets",
    url: "https://kaspreadsheet.com/search-917/name/Shoes.html",
    image:
      "https://readdy.ai/api/search-image?query=A%20coordinated%20matching%20loungewear%20set%20with%20a%20hoodie%20and%20joggers%20arranged%20together%20on%20a%20warm%20honey%20beige%20backdrop%20with%20soft%20natural%20light%2C%20minimal%20e-commerce%20product%20photography%2C%20high%20detail%2C%20clean%20balanced%20composition&width=600&height=600&seq=cat-sets-v2&orientation=squarish",
    tagline: "Matching outfits & sets",
  },
  {
    name: "Underwear/Underpants",
    url: "https://kaspreadsheet.com/search-918/name/Shoes.html",
    image:
      "https://readdy.ai/api/search-image?query=A%20neat%20stack%20of%20folded%20soft%20heather%20grey%20and%20white%20cotton%20underwear%20on%20a%20light%20slate%20linen%20surface%20against%20a%20soft%20powder%20blue%20grey%20studio%20backdrop%2C%20gentle%20diffused%20lighting%2C%20minimal%20e-commerce%20product%20photography%2C%20high%20detail&width=600&height=600&seq=cat-underwear-v2&orientation=squarish",
    tagline: "Essentials & base layers",
  },
  {
    name: "Jersey",
    url: "https://kaspreadsheet.com/search-919/name/Shoes.html",
    image:
      "https://readdy.ai/api/search-image?query=A%20modern%20green%20and%20cream%20sports%20jersey%20with%20subtle%20stripe%20details%20laid%20flat%20on%20a%20warm%20olive%20toned%20studio%20backdrop%2C%20soft%20natural%20lighting%2C%20minimal%20e-commerce%20product%20photography%2C%20high%20detail%2C%20clean%20balanced%20composition&width=600&height=600&seq=cat-jersey-v2&orientation=squarish",
    tagline: "Sports & football jerseys",
  },
  {
    name: "Accessories",
    url: "https://kaspreadsheet.com/search-920/name/Shoes.html",
    image:
      "https://readdy.ai/api/search-image?query=A%20collection%20of%20minimal%20fashion%20accessories%20including%20round%20sunglasses%20and%20a%20leather%20watch%20arranged%20on%20a%20warm%20taupe%20studio%20backdrop%2C%20gentle%20natural%20lighting%2C%20minimal%20e-commerce%20product%20photography%2C%20high%20detail%2C%20balanced%20composition&width=600&height=600&seq=cat-accessories-v2&orientation=squarish",
    tagline: "Watches, shades & more",
  },
  {
    name: "Bags",
    url: "https://kaspreadsheet.com/search-921/name/Shoes.html",
    image:
      "https://readdy.ai/api/search-image?query=A%20structured%20minimalist%20olive%20green%20backpack%20standing%20upright%20on%20a%20soft%20stone%20surface%20against%20a%20warm%20cream%20studio%20backdrop%2C%20gentle%20natural%20lighting%2C%20minimal%20e-commerce%20product%20photography%2C%20high%20detail%2C%20clean%20composition&width=600&height=600&seq=cat-bags-v2&orientation=squarish",
    tagline: "Backpacks & everyday bags",
  },
  {
    name: "Belts",
    url: "https://kaspreadsheet.com/search-922/name/Shoes.html",
    image:
      "https://readdy.ai/api/search-image?query=A%20coiled%20cognac%20brown%20leather%20belt%20with%20a%20brushed%20metal%20buckle%20resting%20on%20warm%20tan%20linen%20against%20a%20soft%20sand%20studio%20backdrop%2C%20gentle%20side%20lighting%2C%20minimal%20e-commerce%20product%20photography%2C%20high%20detail%2C%20clean%20composition&width=600&height=600&seq=cat-belts-v2&orientation=squarish",
    tagline: "Leather & woven belts",
  },
  {
    name: "Perfumes",
    url: "https://kaspreadsheet.com/search-923/name/Shoes.html",
    image:
      "https://readdy.ai/api/search-image?query=A%20minimal%20amber%20glass%20perfume%20bottle%20with%20soft%20warm%20backlighting%20on%20a%20peach%20toned%20studio%20backdrop%2C%20gentle%20glow%2C%20minimal%20e-commerce%20product%20photography%2C%20high%20detail%2C%20elegant%20balanced%20composition&width=600&height=600&seq=cat-perfumes-v2&orientation=squarish",
    tagline: "Fragrances & scents",
  },
  {
    name: "Other Stuff",
    url: "https://kaspreadsheet.com/search-924/name/Shoes.html",
    image:
      "https://readdy.ai/api/search-image?query=A%20minimal%20flat%20lay%20of%20assorted%20lifestyle%20gadgets%20including%20a%20notebook%2C%20sunglasses%20and%20small%20accessories%20on%20a%20warm%20off-white%20stone%20surface%2C%20soft%20diffused%20lighting%2C%20clean%20editorial%20product%20photography%2C%20high%20detail%2C%20balanced%20composition&width=600&height=600&seq=cat-other-v2&orientation=squarish",
    tagline: "Everything else worth finding",
  },
];